export class MaintenanceModeError extends Error {}